/**
 * Cart Drawer
 * - Open/close behaviour for the AJAX cart drawer (section: cart-drawer.liquid).
 * - Buy x Get y (BXGY) free-product logic, ported from
 *   cottonink-current-theme/layout/theme.liquid (inline script block).
 */
(function () {
  var routes = window.routes || {
    cartUrl: '/cart',
    cartAddUrl: '/cart/add',
    cartChangeUrl: '/cart/change'
  };

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }
  // Open the drawer via event.
  document.addEventListener('cart:open', function () {
    openDrawer();
  });

  // Open the drawer when the header cart icon is clicked.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-drawer-trigger]');
    if (!trigger) return;
    e.preventDefault();
    openDrawer();
  });

  // Close the drawer via close button / overlay.
  document.addEventListener('click', function (e) {
    var closeEl = e.target.closest('[data-cart-drawer-close]');
    if (!closeEl) return;
    e.preventDefault();
    closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Refresh the cart drawer markup (and header cart count) via the Section
  // Rendering API, since this section is rendered once and otherwise static.
  function refreshCartDrawerMarkup(options) {
    var drawer = getDrawer();
    if (!drawer) return Promise.resolve();

    options = options || {};
    var forceOpen = !!options.forceOpen;
    var wasOpen =
      drawer.classList.contains('is-open') ||
      drawer.getAttribute('aria-hidden') === 'false';

    return fetch(
      (routes.rootUrl || '/') + '?section_id=cart-drawer',
      { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    )
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (!newDrawer) return;

        if (forceOpen) {
          // Insert closed first so CSS slide-in can run (avoid "pop" open).
          newDrawer.classList.remove('is-open');
          newDrawer.setAttribute('aria-hidden', 'true');
          drawer.replaceWith(newDrawer);
          requestAnimationFrame(function () {
            requestAnimationFrame(openDrawer);
          });
          return;
        }

        if (wasOpen) {
          // Already open (e.g. qty change inside drawer): keep open, no re-animate.
          newDrawer.classList.add('is-open');
          newDrawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('cart-drawer-open');
        } else {
          // Stay closed (e.g. cart page refresh must not flash-open).
          newDrawer.classList.remove('is-open');
          newDrawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('cart-drawer-open');
        }
        drawer.replaceWith(newDrawer);
      })
      .catch(function () {});
  }

  function updateHeaderCartCount(count) {
    var dotEl = document.querySelector('[data-header-cart-dot]');
    if (dotEl && typeof count === 'number') {
      dotEl.classList.toggle('is-visible', count > 0);
    }
  }

  document.addEventListener('cart:refresh', function (e) {
    // The cart page is rendered server side and is not refreshed by the drawer
    // markup swap, so reload it to keep the list, totals and BXGY block in sync.
    if (isCartPage()) {
      window.location.reload();
      return;
    }

    var forceOpen = !!(e.detail && e.detail.open);

    fetch((routes.cartUrl || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateHeaderCartCount(cart.item_count); })
      .catch(function () {});

    refreshCartDrawerMarkup({ forceOpen: forceOpen }).then(function () {
      decorateBxgyLines();
      setTimeout(runBxgySync, 50);
    });
  });

  // --- Buy x Get y (BXGY) helpers -------------------------------------
  //
  // Two independent promos exist (settings "Buy x Get y 1 / 2") and both can apply to the
  // same cart. snippets/bxgy-offer.liquid renders a hidden [data-bxgy-data] node whose
  // `data-fix` lists the (tagged) free-gift lines that must be reduced / removed
  // ("lineKey~quantity,...") and whose `data-notice-*` describe the promo 2 line notice.
  // The helpers below apply them.

  function isCartPage() {
    return !!document.querySelector('[data-cart-page]');
  }

  // The cart page and the drawer can both render the data node. Prefer the
  // page one so a single node drives the sync.
  function getBxgyNode() {
    return document.querySelector('[data-cart-page] [data-bxgy-data]') ||
      document.querySelector('[data-cart-drawer] [data-bxgy-data]');
  }

  function parseBxgyFix(raw) {
    var updates = {};
    var count = 0;
    (raw || '').split(',').forEach(function (record) {
      var parts = record.split('~');
      if (parts.length !== 2 || !parts[0]) return;
      var qty = parseInt(parts[1], 10);
      if (isNaN(qty) || qty < 0) return;
      updates[parts[0]] = qty;
      count++;
    });
    return count ? updates : null;
  }

  // Safety net against a sync -> refresh -> sync loop (max 3 syncs / 10s).
  function bxgySyncAllowed() {
    var storageKey = 'ci-bxgy-sync';
    try {
      var now = Date.now();
      var log = JSON.parse(sessionStorage.getItem(storageKey) || '[]').filter(function (t) {
        return now - t < 10000;
      });
      if (log.length >= 3) return false;
      log.push(now);
      sessionStorage.setItem(storageKey, JSON.stringify(log));
    } catch (err) {}
    return true;
  }

  // Gifts added manually (product page, collection, ...) are plain cart lines, so the
  // "price changes at checkout" notice (promo 2) cannot be rendered by the line snippets
  // (they do not know the entitlement). bxgy-offer.liquid lists the lines in
  // data-notice-keys + the localized text in data-notice-text; add the notice here.
  function decorateBxgyLines() {
    document.querySelectorAll('[data-bxgy-data]').forEach(function (node) {
      var text = node.getAttribute('data-notice-text');
      var keys = (node.getAttribute('data-notice-keys') || '').split(',').filter(function (k) { return k; });
      if (!text || !keys.length) return;
      var scope = node.closest('[data-cart-page], [data-cart-drawer]') || document;
      scope.querySelectorAll('[data-line-key]').forEach(function (line) {
        if (keys.indexOf(line.getAttribute('data-line-key')) === -1) return;
        if (line.querySelector('.bxgy-item-notice')) return;
        var notice = document.createElement('p');
        notice.className = 'bxgy-item-notice';
        notice.textContent = text;
        var info = line.querySelector('.cart-drawer__item-info, .cart-item-info');
        (info || line).appendChild(notice);
      });
    });
  }

  var bxgySyncing = null;

  // Removes / reduces free-gift lines that are no longer valid (minimum spend
  // not met any more, gift of the inactive promo, more units than entitled) in
  // ONE request. Resolves true when the cart was changed.
  function syncBxgy() {
    if (bxgySyncing) return bxgySyncing;
    var node = getBxgyNode();
    if (!node) return Promise.resolve(false);
    var updates = parseBxgyFix(node.getAttribute('data-fix'));
    if (!updates || !bxgySyncAllowed()) return Promise.resolve(false);

    bxgySyncing = fetch((routes.cartUrl || '/cart') + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.ok;
    }).catch(function () {
      return false;
    }).finally(function () {
      bxgySyncing = null;
    });
    return bxgySyncing;
  }

  function runBxgySync() {
    return syncBxgy().then(function (changed) {
      if (changed) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      return changed;
    });
  }

  // Also validate on page load (cart changed elsewhere, promo switched off in
  // the theme settings, ...).
  function initBxgy() {
    decorateBxgyLines();
    runBxgySync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBxgy);
  } else {
    initBxgy();
  }

  function getVariantIdFromForm(formEl) {
    var hidden = formEl.querySelector('input[data-variant-id]');
    if (hidden) return parseInt(hidden.value, 10);
    var select = formEl.querySelector('[data-variant-select]');
    return select ? parseInt(select.value, 10) : null;
  }

  function setAddButtonState(btn, available) {
    btn.disabled = !available;
  }

  // Jika ada free product add-on di cart, saat user ubah quantity ( +/- / remove ) → jalankan request lalu refresh drawer
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-action="update-item-quantity"], a[data-action="remove-item"]');
    if (!link || !link.closest('[data-cart-drawer]')) return;
    e.preventDefault();
    e.stopPropagation();
    fetch(link.href, { method: 'GET', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="add-free-product-to-cart"]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('[data-free-product-form]');
    if (!form) return;
    e.preventDefault();
    var variantId = getVariantIdFromForm(form);
    if (!variantId) return;
    // Promo 1 (automatic discount): the line is tagged with a hidden (underscore) property
    // so it can be told apart, locked to the entitlement and removed when the promo is no
    // longer met.
    // Promo 2 (discount code, "tebus murah"): NO property. The product is also sold normally,
    // so the line must be the very same line a manual add to cart creates (same variant, no
    // property = they merge into ONE line); bxgy-offer.liquid recognises it by the product.
    var promo = form.getAttribute('data-promo') === '2' ? '2' : '1';
    var lineProperties = promo === '2' ? undefined : { _bxgy: promo };
    btn.disabled = true;

    // A free gift is a normal product for the pre-order rule: "Tidak bisa checkout
    // product pre-order dengan product ready stock" also applies to it (the same guard
    // used by the product page add to cart, see assets/ci-preorder-cart.js).
    var handle = form.getAttribute('data-product-handle');
    var guard = Promise.resolve();
    if (handle && window.CiPreorderCart && typeof window.CiPreorderCart.assertCanAddProduct === 'function') {
      guard = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (product) {
        return product ? window.CiPreorderCart.assertCanAddProduct(product) : null;
      });
    }

    guard.then(function () {
      return fetch((routes.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: lineProperties }] })
      });
    }).then(function (r) {
      if (r.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {
        return r.json().then(function (err) { throw err; });
      }
    }).catch(function (err) {
      if (err && err.code === 'PREORDER_CART_MIX' && window.CiPreorderCart) {
        window.CiPreorderCart.showError(err.message, btn);
        return;
      }
      if (err && err.description) alert(err.description);
    }).finally(function () {
      btn.disabled = false;
    });
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.cart-drawer__free-product-variant-select')) return;
    var form = e.target.closest('[data-free-product-form]');
    if (!form) return;
    var opt = e.target.options[e.target.selectedIndex];
    var btn = form.querySelector('[data-action="add-free-product-to-cart"]');
    if (btn) setAddButtonState(btn, opt && parseInt(opt.getAttribute('data-available'), 10) === 1);
  });

  // Order note toggle (Prestige Cart__NoteButton parity)
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-action="toggle-cart-note"]');
    if (!toggle || !toggle.closest('[data-cart-drawer]')) return;
    e.preventDefault();
    var drawer = getDrawer();
    if (!drawer) return;
    var panel = drawer.querySelector('[data-cart-note-panel]');
    if (!panel) return;
    var isOpen = panel.getAttribute('aria-hidden') === 'false';
    panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    drawer.classList.toggle('has-note-open', !isOpen);
    if (!isOpen) {
      var textarea = panel.querySelector('textarea');
      if (textarea) textarea.focus();
    }
  });

  // Checkout button in cart drawer redirects to cart page (/cart)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-drawer] .cart-drawer__checkout-btn:not(.cart-drawer__note-save)');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
    var drawer = getDrawer();
    var textarea = drawer ? drawer.querySelector('textarea[name="note"]') : null;
    var noteVal = textarea ? textarea.value : '';

    if (noteVal && noteVal.trim()) {
      btn.setAttribute('disabled', 'disabled');
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ note: noteVal })
      }).finally(function () {
        window.location.href = cartUrl;
      });
    } else {
      window.location.href = cartUrl;
    }
  });
})();
